import { LoadChatbot } from './thirdPartyScripts/podiumChatBot'
import { initializeGoogleTags } from './content/services/google-tag-manager'
import { InitialDataResponse } from './content/services/models/initialDataResponse'
import { setDebugMode } from './content/utilities/setDebugMode'
import { scrollbarWidthUnits } from './content/utilities/getScrollBarWidth'
import { verticalHeightUnits } from './content/utilities/verticalHeightUnits'
import { onWindowResize } from './content/utilities/onWindowResize'
import { LoadRum24x7 } from './thirdPartyScripts/rum24x7'
import { InitializeResult } from './content/services/cms.service'

/**
 * Handles running anything that must be ran AFTER initial data is available but BEFORE <App /> is rendered
 */
export const init = (occConfigurationApi: InitializeResult) => {
    // Generate vertical height units
    verticalHeightUnits()
    scrollbarWidthUnits()

    // Code to run every time window resizes
    onWindowResize(() => {
        verticalHeightUnits()
        scrollbarWidthUnits()
    })

    setDebugMode()

    initializeGoogleTags(occConfigurationApi.gtmId)

    // If we want to load captcha script programatically
    // if (occConfigurationApi.recaptcha.siteKey)
    //     loadScript('recaptchaScript', 'https://www.google.com/recaptcha/api.js')

    // Load RUM
    if (occConfigurationApi.rumId) LoadRum24x7(occConfigurationApi.rumId)

    // Load Podium Chat Bot
    if (occConfigurationApi.podiumChatBotOrgId) LoadChatbot(occConfigurationApi.podiumChatBotOrgId)
}
